import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

/**
 * The top of a page: what it is, and one sentence about it.
 *
 * Twelve pages used to write this by hand, each with its own responsive
 * `fontSize` override on `variant="h1"` — in four different sets of values,
 * so no two page titles were quite the same size. The scale lives here now.
 */
/**
 * Height reserved for a lede whose wording depends on data.
 *
 * Three pages name the city in their opening sentence, and the city arrives
 * from the API a moment after the page paints. Measured in the browser, the
 * sentence goes from one line to two on a desktop and from one to three on a
 * phone — so everything below it used to drop by 26px, then again. Reserving
 * the settled height means the sentence fills in without moving anything.
 */
const RESERVED_LEDE = { xs: 79, md: 53 };

function PageHeader({ title, lede, reserveLede = false, action }) {
  return (
    <Stack
      direction={{ xs: 'column', sm: action ? 'row' : 'column' }}
      sx={{
        gap: 2,
        alignItems: { sm: action ? 'center' : 'stretch' },
        justifyContent: 'space-between',
        mb: 3.5,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography variant="h1" component="h1" sx={{ fontSize: { xs: '2rem', md: '2.5rem' } }}>
          {title}
        </Typography>
        {lede && (
          <Typography
            variant="subtitle1"
            component="p"
            sx={{ maxWidth: 680, minHeight: reserveLede ? RESERVED_LEDE : undefined }}
          >
            {lede}
          </Typography>
        )}
      </Box>

      {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
    </Stack>
  );
}

export default PageHeader;
